export const EquipmentDetailsFooter = (): React.ReactNode => {
  return <div className="p-10" />;
};
